function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license
 * Copyright (c) 2017 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { css, CSSResult, unsafeCSS } from 'lit';
import { ThemePropertyMixin } from './vaadin-theme-property-mixin.js';
export { css, unsafeCSS };
/**
 * @typedef {Object} Theme
 * @property {string} themeFor
 * @property {CSSResult[]} styles
 * @property {string | string[]} [include]
 * @property {string} [moduleId]
 *
 * @typedef {CSSResult[] | CSSResult} CSSResultGroup
 */

/**
 * @type {Theme[]}
 */

var themeRegistry = [];
/**
 * Check if the custom element type has themes applied.
 * @param {Function} elementClass
 * @returns {boolean}
 */

function classHasThemes(elementClass) {
  return elementClass && Object.prototype.hasOwnProperty.call(elementClass, '__themes');
}
/**
 * Check if the custom element type has themes applied.
 * @param {string} tagName
 * @returns {boolean}
 */


function hasThemes(tagName) {
  return classHasThemes(customElements.get(tagName));
}
/**
 * Flattens the styles into a single array of styles.
 * @param {CSSResultGroup} styles
 * @param {CSSResult[]} result
 * @returns {CSSResult[]}
 */


function flattenStyles() {
  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return [styles].flat(Infinity).filter(function (style) {
    if (style instanceof CSSResult) {
      return true;
    }

    console.warn('An item in styles is not of type CSSResult. Use `unsafeCSS` or `css`.');
    return false;
  });
}
/**
 * Registers CSS styles for a component type. Make sure to register the styles before
 * the first instance of a component of the type is attached to DOM.
 *
 * @param {string} themeFor The local/tag name of the component type to register the styles for
 * @param {CSSResultGroup} styles The CSS style rules to be registered for the component type
 * matching themeFor and included in the local scope of each component instance
 * @param {{moduleId?: string, include?: string | string[]}} options Additional options
 * @return {void}
 */


export function registerStyles(themeFor, styles) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (themeFor) {
    if (hasThemes(themeFor)) {
      console.warn("The custom element definition for \"".concat(themeFor, "\"\n      was finalized before a style module was registered.\n      Make sure to add component specific style modules before\n      importing the corresponding custom element."));
    }
  }

  styles = flattenStyles(styles);

  if (window.Vaadin && window.Vaadin.styleModules) {
    window.Vaadin.styleModules.registerStyles(themeFor, styles, options);
  } else {
    themeRegistry.push({
      themeFor: themeFor,
      styles: styles,
      include: options.include,
      moduleId: options.moduleId
    });
  }
}
/**
 * Returns all registered themes. By default the themeRegistry is returned as is.
 * In case the style-modules adapter is imported, the themes are obtained from there instead
 * @returns {Theme[]}
 */

function getAllThemes() {
  if (window.Vaadin && window.Vaadin.styleModules) {
    return window.Vaadin.styleModules.getAllThemes();
  }

  return themeRegistry;
}
/**
 * Returns true if the themeFor string matches the tag name
 * @param {string} themeFor
 * @param {string} tagName
 * @returns {boolean}
 */


function matchesThemeFor(themeFor, tagName) {
  return (themeFor || '').split(' ').some(function (themeForToken) {
    return new RegExp("^".concat(themeForToken.split('*').join('.*'), "$"), 'u').test(tagName);
  });
}
/**
 * Maps the moduleName to an include priority number which is used for
 * determining the order in which styles are applied.
 * @param {string} moduleName
 * @returns {number}
 */


function getIncludePriority() {
  var moduleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var includePriority = 0;

  if (moduleName.startsWith('lumo-') || moduleName.startsWith('material-')) {
    includePriority = 1;
  } else if (moduleName.startsWith('vaadin-')) {
    includePriority = 2;
  }

  return includePriority;
}
/**
 * Gets an array of CSSResults matching the include property of the theme.
 * @param {Theme} theme
 * @returns {CSSResult[]}
 */


function getIncludedStyles(theme) {
  var includedStyles = [];

  if (theme.include) {
    [].concat(theme.include).forEach(function (includeModuleId) {
      var includedTheme = getAllThemes().find(function (s) {
        return s.moduleId === includeModuleId;
      });

      if (includedTheme) {
        includedStyles.push.apply(includedStyles, _toConsumableArray(getIncludedStyles(includedTheme)).concat(_toConsumableArray(includedTheme.styles)));
      } else {
        console.warn("Included moduleId ".concat(includeModuleId, " not found in style registry"));
      }
    }, theme.styles);
  }

  return includedStyles;
}
/**
 * Includes the styles to the template.
 * @param {CSSResult[]} styles
 * @param {HTMLTemplateElement} template
 */


function addStylesToTemplate(styles, template) {
  var styleEl = document.createElement('style');
  styleEl.innerHTML = styles.map(function (style) {
    return style.cssText;
  }).join('\n');
  template.content.appendChild(styleEl);
}
/**
 * Returns an array of themes that should be used for styling a component matching
 * the tag name. The array is sorted by the include order.
 * @param {string} tagName
 * @returns {Theme[]}
 */


function getThemes(tagName) {
  var defaultModuleName = "".concat(tagName, "-default-theme");
  var themes = getAllThemes() // Filter by matching themeFor properties
  .filter(function (theme) {
    return theme.moduleId !== defaultModuleName && matchesThemeFor(theme.themeFor, tagName);
  }).map(function (theme) {
    return _objectSpread(_objectSpread({}, theme), {}, {
      // Prepend styles from included themes
      styles: [].concat(_toConsumableArray(getIncludedStyles(theme)), _toConsumableArray(theme.styles)),
      // Map moduleId to includePriority
      includePriority: getIncludePriority(theme.moduleId)
    });
  }) // Sort by includePriority
  .sort(function (themeA, themeB) {
    return themeB.includePriority - themeA.includePriority;
  });

  if (themes.length > 0) {
    return themes;
  } // No theme modules found, return the default module if it exists


  return getAllThemes().filter(function (theme) {
    return theme.moduleId === defaultModuleName;
  });
}
/**
 * @polymerMixin
 * @mixes ThemePropertyMixin
 */


export var ThemableMixin = function ThemableMixin(superClass) {
  return /*#__PURE__*/function (_ThemePropertyMixin) {
    _inherits(VaadinThemableMixin, _ThemePropertyMixin);

    var _super = _createSuper(VaadinThemableMixin);

    function VaadinThemableMixin() {
      _classCallCheck(this, VaadinThemableMixin);

      return _super.apply(this, arguments);
    }

    _createClass(VaadinThemableMixin, null, [{
      key: "finalize",
      value:
      /**
       * Covers PolymerElement based component styling
       * @protected
       */
      function finalize() {
        _get(_getPrototypeOf(VaadinThemableMixin), "finalize", this).call(this); // Make sure not to run the logic intended for PolymerElement when LitElement is used.


        if (this.elementStyles) {
          return;
        }

        var template = this.prototype._template;

        if (!template || classHasThemes(this)) {
          return;
        }

        addStylesToTemplate(this.getStylesForThis(), template);
      }
      /**
       * Covers LitElement based component styling
       *
       * @protected
       */

    }, {
      key: "finalizeStyles",
      value: function finalizeStyles(styles) {
        // The "styles" object originates from the "static get styles()" function of
        // a LitElement based component. The theme styles are added after it
        // so that they can override the component styles.
        var themeStyles = this.getStylesForThis();
        return styles ? [].concat(_toConsumableArray(_get(_getPrototypeOf(VaadinThemableMixin), "finalizeStyles", this).call(this, styles)), _toConsumableArray(themeStyles)) : themeStyles;
      }
      /**
       * Get styles for the component type
       *
       * @private
       */

    }, {
      key: "getStylesForThis",
      value: function getStylesForThis() {
        var parent = Object.getPrototypeOf(this.prototype);
        var inheritedThemes = (parent ? parent.constructor.__themes : []) || [];
        this.__themes = [].concat(_toConsumableArray(inheritedThemes), _toConsumableArray(getThemes(this.is)));

        var themeStyles = this.__themes.flatMap(function (theme) {
          return theme.styles;
        }); // Remove duplicates


        return themeStyles.filter(function (style, index) {
          return index === themeStyles.lastIndexOf(style);
        });
      }
    }]);

    return VaadinThemableMixin;
  }(ThemePropertyMixin(superClass));
};
export { themeRegistry as __themeRegistry };